import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type ToolsKitchen2IconProps = CreateIconComponentProps;
export const ToolsKitchen2Icon: React.FC<ToolsKitchen2IconProps> = ({
  title = 'ToolsKitchen2',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <path
      fill="currentColor"
      d="M19 3h1a1 1 0 0 0-1.69-.724L19 3Zm0 12v1a1 1 0 0 0 1-1h-1Zm-5 0-1 .006A1 1 0 0 0 14 16v-1Zm6 0a1 1 0 1 0-2 0h2Zm-1 6v1a1 1 0 0 0 1-1h-1Zm-1 0h-1a1 1 0 0 0 1 1v-1Zm1-3a1 1 0 1 0-2 0h2ZM9 4a1 1 0 0 0-2 0h2ZM7 21a1 1 0 1 0 2 0H7ZM6 4a1 1 0 0 0-2 0h2Zm6 0a1 1 0 1 0-2 0h2Zm6-1v12h2V3h-2Zm1 11h-5v2h5v-2Zm-4 .994c-.011-1.827.039-3.538.635-5.337.59-1.785 1.745-3.73 4.055-5.933l-1.38-1.448c-2.506 2.39-3.863 4.606-4.574 6.752-.706 2.132-.748 4.124-.736 5.978l2-.012ZM18 15v6h2v-6h-2Zm1 5h-1v2h1v-2Zm0 1v-3h-2v3h2ZM7 4v17h2V4H7ZM4 4v3h2V4H4Zm0 3a4 4 0 0 0 4 4V9a2 2 0 0 1-2-2H4Zm4 4a4 4 0 0 0 4-4h-2a2 2 0 0 1-2 2v2Zm4-4V4h-2v3h2Z"
    />
  </CreateIconComponent>
);
